import React, { PureComponent } from 'react';

import { DateTimePicker } from '../DateTimePicker';
import { DropdownDeprecated } from '../deprecated/DropdownDeprecated';
import { Input } from '../Input';
import { LabeledProps as FormFieldProps, Labeled } from '../Labeled';

export class FormField extends PureComponent<FormFieldProps> {
  public static Dropdown = DropdownDeprecated;
  public static Input: typeof Input = Input;
  public static DateTimePicker = DateTimePicker;

  public render() {
    return <Labeled {...this.props} />;
  }
}
